<template>
    <div class="price-information">

        <div class="d-md-flex align-items-center mb-3 mb-md-0">
            <div class="price-box">Итого: <span class="font-700">{{store.common_price.price}} RUB</span></div>
            <div class="dividing-line"></div>
            <div class="price-box">Скидка: <span class="font-700">{{discount_price}} RUB</span></div>
            <div class="dividing-line"></div>
            <div class="price-box">Итого со скидкой: <span
                class="font-700">{{(store.common_price.price - discount_price)}} RUB</span></div>

        </div>

<!--        <div class="font-700 text-btn" @click="changeStep(2)" v-if="order.state.step  == 1">Далее</div>-->
        <button id="next" class="button btn-small" @click="changeStep(2)" v-if="order.state.step  == 1">Далее</button>
        <button class="button btn-small" @click="passValidation()" v-if="order.state.step  == 2">Оформить заказ</button>

    </div>
</template>

<script>
    import store from '../../../services/data';
    import order from '../../../services/order';

    import {requiredRule, checkbox, deliveryAddressRule, pickUpAddressRule, delivery_distance, pick_up_distance} from '../../../services/validation';

    const touchMap = new WeakMap();

    export default {
        data() {
            return {
                store: store,
                order: order,
            }
        },

        mounted() {
            this.store.getCommonPrice();
        },

        computed: {
            user() {
                return this.$store.getters.getUser;
            },

            discount_price() {
                let items = this.store.state.basket_items;
                let discount_price = 0;
                let discount_price_item;
                items.forEach(item => {
                    if (item.discount_flag != 0) {
                        discount_price_item = 0; //this.store.getFinalPrice(item.threeHoure_price, item.day_price, item.count, item.not_apply_number_days, true, item.discount_old_price - item.discount_new_price);
                        discount_price = discount_price + discount_price_item;
                    }
                    else if (item.discount) {
                        discount_price_item = Math.round(this.store.getFinalPrice(item.threeHoure_price, item.day_price, item.count, item.not_apply_number_days, false, 0) * item.discount / 100); //Math.round(item.day_price * item.count * this.store.rate.count * item.discount / 100);
                        discount_price = discount_price + discount_price_item;
                    }
                    else if(item.not_apply_discount == 0) {
                        discount_price_item = Math.round(this.store.getFinalPrice(item.threeHoure_price, item.day_price, item.count, item.not_apply_number_days, false, 0) * this.store.common_price.discount / 100); // Math.round(item.day_price * item.count * this.store.rate.count * this.store.common_price.discount / 100);
                        discount_price = discount_price + discount_price_item;
                    } else {
                        discount_price_item = 0;
                        discount_price = discount_price + discount_price_item;
                    }
                });
                // return  Math.round(this.store.common_price.price * this.store.common_price.discount / 100)
                this.store.common_price.discount_price = discount_price;
                return discount_price;
            }
        },

        methods: {
            changeStep(e) {
                if(!this.store.state.dates.start || !this.store.state.dates.end ||
                    !this.store.state.timeStart.HH || !this.store.state.timeEnd.HH || !this.store.state.timeStart.mm || !this.store.state.timeEnd.mm) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Внимание',
                        html: 'Вы не выбрали период аренды.',
                    });
                }
                else {
                    if(this.user) {
                        this.scrollTop();
                        this.order.state.step = e;
                    }
                    else this.order.state.step = 3;
                }
            },

            passValidation() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    let error = [];
                    let delivery_type = this.$v.order.postData.delivery_type.required;
                    let delivery_distance = this.$v.order.postData.delivery_outside_distance.required;
                    let pick_up_distance = this.$v.order.postData.pick_up_outside_distance.required;
                    let payment_type = this.$v.order.postData.payment_type.required;
                    let delivery_city = this.$v.order.delivery_address.city.required;
                    // let delivery_street = this.$v.order.delivery_address.street.required;
                    // let delivery_house = this.$v.order.delivery_address.house.required;
                    let pick_up_city = this.$v.order.pick_up_address.city.required;
                    // let pick_up_street = this.$v.order.pick_up_address.street.required;
                    // let pick_up_house = this.$v.order.pick_up_address.house.required;
                    let confirm = this.$v.order.state.confirm.sameAs;
                    if(!delivery_type) error.push('Выберите способ доставки');
                    if(!payment_type) error.push(' укажите способ оплаты');
                    if(!confirm) error.push(' согласитесь с условиями проката');

                    if(!delivery_distance) error.push(' введите расстояние до адреса доставки в километрах от МКАД');
                    if(!pick_up_distance) error.push(' введите расстояние до адреса увоза в километрах от МКАД');
                    // if(!delivery_city || !delivery_street || !delivery_house) error.push(' укажите адрес доставки');
                    // if(!pick_up_city || !pick_up_street || !pick_up_house) error.push(' укажите адрес увоза');

                    if(!delivery_city) error.push(' укажите адрес доставки');
                    if(!pick_up_city) error.push(' укажите адрес увоза');

                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: error,
                    });
                    return false;
                }
                else if((this.order.postData.email && !this.order.state.email_valid) || (this.order.postData.email && this.order.state.email_error)) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте email, который вы ввели при оформлении заказа.',
                    });
                    return false;
                }
                else {
                    this.store.updateBasketWithPrice();
                    if(this.user) {
                        document.getElementById('app').scrollIntoView({behavior: "smooth"});
                        this.order.sendOrder();
                    }
                }
            },

            scrollTop() {
                document.getElementById('app').scrollIntoView({behavior: "smooth"})
            },
        },

        validations: {
            order: {
                postData: {
                    delivery_type: requiredRule,
                    payment_type: requiredRule,
                    delivery_outside_distance: delivery_distance,
                    pick_up_outside_distance: pick_up_distance,
                },

                delivery_address: {
                    city: deliveryAddressRule,
                    // street: deliveryAddressRule,
                    // house: deliveryAddressRule,
                },

                pick_up_address: {
                    city: pickUpAddressRule,
                    // street: pickUpAddressRule,
                    // house: pickUpAddressRule,
                },

                state: {
                    confirm: checkbox
                }
            },
        }
    }
</script>
